  import GeneratePage from "./pages/GeneratePage";
  import ChatGptPage from "./pages/ChatGptPage";

  const generateRoutes = [
    { path: "/generate", element: <GeneratePage /> },
    { path: "/generate/chatgpt", element: <ChatGptPage /> },
    { path: "/generate/gemini", element: <ChatGptPage /> },
    { path: "/generate/claude", element: <ChatGptPage /> },
  ];

  export default generateRoutes;